import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { DefaultBorder } from '../../styles/styles';

const { colors, spacing, common } = THEME;

export const styleSheet = StyleSheet.create({
	authorContainer: {
		marginTop: spacing.sm,
		textAlign: 'left',
		width: '100%',
	},
	authorInput: {
		backgroundColor: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		fontSize: 13,
		padding: spacing.sm,
		width: '100%',
		minHeight: 32,
		maxHeight: 32,
		[THEME.queries.md]: {
			fontSize: 16,
			padding: 12,
			minHeight: 44,
			maxHeight: 44,
		},
	},
	authorText: {
		color: 'inherit',
		fontFamily: 'Sora',
		fontSize: 20,
		fontWeight: 600,
		lineHeight: '24px',
		[THEME.queries.md]: {
			fontSize: 14,
			lineHeight: '18px',
		},
		[THEME.queries.xs]: {
			fontSize: 12,
			lineHeight: '16px',
		},
	},
	charCount: {
		color: colors.text.dark,
		fontSize: 12,
		[THEME.queries.md]: {
			fontSize: 13,
			fontWeight: 500,
		},
	},
	charCountError: {
		color: colors.danger.main,
		fontWeight: 600,
	},
	checkbox: {
		marginRight: spacing.sm,
	},
	checkboxGrid: {
		display: 'grid',
		gap: spacing.sm,
		gridTemplateColumns: '1fr 1fr',
		marginBottom: spacing.md,
		[THEME.queries.xs]: {
			gridTemplateColumns: '1fr',
			gap: spacing.xs,
		},
	},
	checkboxLabel: {
		alignItems: 'center',
		color: colors.text.light,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 13,
		padding: '4px 0',
		[THEME.queries.md]: {
			fontSize: 14,
			padding: '8px 0',
		},
	},
	colorPicker: {
		background: colors.background.light,
		border: 'none',
		borderRadius: common.borderRadius,
		cursor: 'pointer',
		gridArea: 'overlay',
		height: spacing.xl,
		padding: 0,
		width: '100%',
	},
	colorPickerGroup: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 5,
	},
	colorPickersContainer: {
		display: 'flex',
		gap: 10,
		marginBottom: 15,
		[THEME.queries.xs]: {
			flexDirection: 'column',
			gap: 8,
		},
	},
	colorPickerWrapper: {
		display: 'grid',
		gridTemplateAreas: '"overlay"',
		placeItems: 'baseline',
		position: 'relative',
		width: '100%',
	},
	controlsPane: {
		backgroundColor: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		maxHeight: 630,
		overflowY: 'auto',
		padding: 40,
		width: 500,
		minWidth: 320,
		[THEME.queries.lg]: {
			width: '100%',
			maxWidth: 500,
			minWidth: 280,
		},
		[THEME.queries.md]: {
			width: 'calc(100% - 32px)',
			maxWidth: 'calc(100vw - 32px)',
			maxHeight: 'none',
			padding: spacing.md,
			order: 1,
			minWidth: 'auto',
			margin: '0 auto',
		},
		[THEME.queries.compactHeight]: {
			padding: 20,
		},
	},
	description: {
		color: colors.text.light,
		fontFamily: 'Sora',
		fontSize: 12,
		fontWeight: 400,
		marginBottom: spacing.md,
		textAlign: 'left',
	},
	editorContainer: {
		backgroundColor: colors.background.main,
		boxSizing: 'border-box',
		display: 'flex',
		gap: spacing.xl,
		height: '100%',
		justifyContent: 'center',
		padding: spacing.md,
		width: '100%',
		overflow: 'hidden',
		[THEME.queries.lg]: {
			gap: spacing.md,
			padding: spacing.sm,
		},
		[THEME.queries.md]: {
			flexDirection: 'column',
			gap: spacing.sm,
			padding: spacing.md,
			height: 'auto',
			overflow: 'visible',
			maxWidth: '100vw',
		},
	},
	errorIndicator: {
		alignItems: 'center',
		backgroundColor: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		marginTop: spacing.md,
		padding: spacing.md,
		width: '100%',
	},
	errorMessage: {
		color: colors.danger.main,
		fontSize: 16,
		textAlign: 'center',
	},
	formGroup: {
		marginBottom: spacing.sm,
		[THEME.queries.compactHeight]: {
			marginBottom: `${spacing.sm / 2}px`,
		},
	},
	generateButton: {
		fontSize: 14,
		width: '100%',
		marginTop: spacing.md,
		[THEME.queries.md]: {
			fontSize: 16,
			padding: '12px 16px',
			marginTop: spacing.sm,
		},
		[THEME.queries.compactHeight]: {
			marginTop: 0,
		},
	},
	hexValue: {
		color: colors.text.dark,
		fontSize: 12,
		fontWeight: 'bold',
		gridArea: 'overlay',
		pointerEvents: 'none',
		transform: 'translate(8px, -8px)',
		zIndex: 1,
	},
	label: {
		color: colors.text.light,
		fontSize: 13,
		fontWeight: 500,
		[THEME.queries.md]: {
			fontSize: 14,
			fontWeight: 600,
		},
	},
	labelContainer: {
		alignItems: 'flex-end',
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: 5,
	},
	logo: {
		height: 72,
		objectFit: 'contain',
		width: 72,
		[THEME.queries.md]: {
			height: 24,
			width: 24,
		},
		[THEME.queries.xs]: {
			height: 20,
			width: 20,
		},
	},
	logoContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.md,
		marginBottom: spacing.md,
		width: '100%',
	},
	optionsSection: {
		marginBottom: 0,
		marginTop: spacing.sm,
		[THEME.queries.md]: {
			marginTop: spacing.md,
			marginBottom: spacing.xs,
		},
		[THEME.queries.compactHeight]: {
			marginTop: `${spacing.sm / 2}px`,
		},
	},
	previewContainer: {
		alignItems: 'flex-start',
		display: 'flex',
		justifyContent: 'flex-start',
		transform: 'scale(0.5)',
		transformOrigin: 'left center',
		width: '100%',
		overflow: 'hidden',
		[THEME.queries.lg]: {
			transform: 'scale(0.6)',
			transformOrigin: 'center center',
		},
		[THEME.queries.md]: {
			transform: 'scale(1)',
			transformOrigin: 'center center',
			justifyContent: 'center',
			overflow: 'visible',
			width: '100%',
			maxWidth: '100%',
		},
		[THEME.queries.xs]: {
			transform: 'scale(1)',
			transformOrigin: 'center center',
			justifyContent: 'center',
			overflow: 'visible',
			width: '100%',
			maxWidth: '100%',
			marginTop: 0,
			marginBottom: 0,
		},
	},
	previewPane: {
		alignItems: 'flex-start',
		backgroundColor: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		display: 'flex',
		flex: '1',
		flexDirection: 'column',
		maxHeight: 630,
		maxWidth: 550,
		overflowY: 'hidden',
		overflowX: 'hidden',
		padding: 40,
		minWidth: 0,
		[THEME.queries.xl]: {
			overflowX: 'auto',
		},
		[THEME.queries.lg]: {
			maxWidth: '100%',
			flex: '1 1 auto',
			overflowX: 'auto',
		},
		[THEME.queries.md]: {
			width: 'calc(100% - 32px)',
			maxWidth: 'calc(100vw - 32px)',
			maxHeight: 'none',
			padding: spacing.md,
			order: 2,
			margin: '0 auto',
			overflowX: 'auto',
		},
		[THEME.queries.compactHeight]: {
			padding: 20,
		},
	},
	previewWrapper: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'row',
		height: '100%',
		justifyContent: 'flex-start',
		marginTop: -120,
		width: '100%',
		[THEME.queries.md]: {
			marginTop: 0,
			justifyContent: 'center',
			alignItems: 'center',
			height: 'auto',
			width: '100%',
			padding: spacing.sm,
		},
		[THEME.queries.xs]: {
			marginTop: 0,
			justifyContent: 'center',
			alignItems: 'center',
			height: 'auto',
			width: '100%',
			padding: spacing.xs,
		},
	},
	ratingContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.sm,
	},
	ratingStar: {
		height: 48,
		width: 48,
		[THEME.queries.md]: {
			height: 16,
			width: 16,
		},
		[THEME.queries.xs]: {
			height: 14,
			width: 14,
		},
	},
	reviewCard: {
		alignItems: 'flex-start',
		backgroundColor: 'var(--dynamic-bg-color)',
		borderRadius: 8,
		boxShadow: 'none',
		boxSizing: 'border-box',
		color: 'var(--dynamic-text-color)',
		display: 'flex',
		flexDirection: 'column',
		height: 566,
		hyphens: 'auto',
		justifyContent: 'flex-start',
		margin: '0 auto',
		overflowWrap: 'break-word',
		padding: 60,
		paddingRight: 50,
		position: 'relative',
		width: 1080,
		wordWrap: 'break-word',
		[THEME.queries.lg]: {
			width: '100%',
			maxWidth: 800,
			padding: 40,
		},
		[THEME.queries.md]: {
			width: '100%',
			maxWidth: '320px',
			minWidth: '280px',
			padding: 20,
			height: 'auto',
			minHeight: '180px',
			margin: '0 auto',
			borderRadius: 8,
		},
		[THEME.queries.xs]: {
			width: '100%',
			maxWidth: '280px',
			minWidth: '240px',
			padding: 16,
			height: 'auto',
			minHeight: '160px',
			margin: '0 auto',
			borderRadius: 8,
		},
		overflow: 'hidden',
	},
	reviewText: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		fontFamily: 'Sora',
		fontSize: 28,
		fontWeight: 600,
		lineHeight: 1.4,
		marginBottom: 30,
		width: '100%',
		[THEME.queries.md]: {
			fontSize: 16,
			lineHeight: 1.3,
			marginBottom: 16,
		},
		[THEME.queries.xs]: {
			fontSize: 14,
			lineHeight: 1.2,
			marginBottom: 12,
		},
	},
	reviewTextContent: {
		hyphens: 'auto',
		overflowWrap: 'anywhere',
		wordBreak: 'break-word',
		width: '100%',
	},
	subtitle: {
		color: colors.text.main,
		fontSize: 16,
		fontWeight: 600,
		margin: 0,
		textAlign: 'left',
		[THEME.queries.md]: {
			fontSize: 18,
			marginBottom: spacing.xs,
		},
	},
	successIndicator: {
		alignItems: 'center',
		backgroundColor: colors.success.light,
		border: `1px solid ${colors.success.main}`,
		borderRadius: common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: 15,
		marginTop: spacing.md,
		padding: spacing.md,
		width: '100%',
	},
	successMessage: {
		color: colors.success.main,
		fontSize: 16,
		textAlign: 'center',
	},
	textarea: {
		backgroundColor: colors.background.light,
		border: DefaultBorder,
		borderRadius: common.borderRadius,
		fontSize: 13,
		minHeight: 100,
		padding: 8,
		resize: 'vertical',
		width: '100%',
		maxWidth: 480,
		boxSizing: 'border-box',
		[THEME.queries.lg]: {
			maxWidth: '100%',
		},
		[THEME.queries.md]: {
			fontSize: 16,
			minHeight: 80,
			padding: 12,
			maxWidth: '100%',
		},
	},
	textareaError: {
		borderColor: colors.danger.main,
	},
	warningMessage: {
		color: colors.warning.main,
		fontSize: 12,
		marginTop: 4,
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 8,
	},
	hiddenImageContainer: {
		position: 'absolute',
		left: '-9999px',
		top: '-9999px',
		pointerEvents: 'none',
		zIndex: -1,
	},
	imageGenerationCard: {
		alignItems: 'flex-start',
		borderRadius: 8,
		boxShadow: 'none',
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		height: 566,
		hyphens: 'auto',
		justifyContent: 'flex-start',
		margin: 0,
		overflowWrap: 'break-word',
		padding: 60,
		paddingRight: 50,
		position: 'relative',
		width: 1080,
		wordWrap: 'break-word',
		overflow: 'hidden',
		fontFamily: 'Sora',
	},
	imageGenerationLogo: {
		height: 72,
		objectFit: 'contain',
		width: 72,
	},
	imageGenerationLogoContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.md,
		marginBottom: spacing.md,
		width: '100%',
	},
	imageGenerationRatingStar: {
		height: 48,
		width: 48,
	},
	imageGenerationReviewText: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		fontFamily: 'Sora',
		fontSize: 28,
		fontWeight: 600,
		lineHeight: 1.4,
		marginBottom: 30,
		width: '100%',
	},
	imageGenerationAuthorText: {
		color: 'inherit',
		fontFamily: 'Sora',
		fontSize: 20,
		fontWeight: 600,
		lineHeight: '24px',
	},
	imageGenerationAuthorContainer: {
		marginTop: spacing.sm,
		textAlign: 'left',
		width: '100%',
	},
	postFrom: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		alignItems: 'center',
	},
	userDropdown: {
		flex: 1,
		maxWidth: 150,
	},
	backgroundImageContainer: {
		display: 'flex',
		gap: spacing.md,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	addBackgroundImageButton: {
		paddingLeft: 0,
	},
	backgroundImagePreviewContainer: {
		display: 'flex',
		gap: spacing.md,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	backgroundImagePreview: {
		height: 100,
		width: 100,
		objectFit: 'cover',
		borderRadius: common.borderRadius,
	},
	summarizeDialogPopup: {
		maxWidth: 460,
		width: '100%',
	},
	summarizeActions: {
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'flex-end',
		marginTop: spacing.md,
	},
	summarizeError: {
		color: colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
});

export const getDynamicStyles = (bgColor: string, textColor: string) => ({
	'--dynamic-bg-color': bgColor,
	'--dynamic-text-color': textColor,
});
